var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "menu-header__section",
      style: { backgroundImage: `url(${_vm.$CDN}${_vm.backgroundImage})` },
    },
    [
      _c("content-container", [
        _c("div", { staticClass: "menu-header__rest-logo-wrapper" }, [
          _c("div", { staticClass: "menu-header__rest-logo" }, [
            _c("img", {
              staticClass: "img-responsive",
              attrs: { src: _vm.$CDN + _vm.restLogo },
            }),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }